import { useId, useState } from 'react';

export const subdivisionTotal = (items) => items.reduce((total, item) => total + Math.round(Number(item.amount || 0) * 100), 0) / 100;

export default function FinanceSubdivisions({ items, onChange, formatCurrency }) {
  const [selected, setSelected] = useState(0);
  const id = useId();
  const active = Math.min(selected, Math.max(0, items.length - 1));
  const item = items[active];
  const editable = Boolean(onChange);

  function add() {
    onChange([...items, { description: '', amount: '' }]);
    setSelected(items.length);
  }

  function update(key, value) {
    onChange(items.map((current, index) => index === active ? { ...current, [key]: value } : current));
  }

  return (
    <section className="subdivisions-panel" aria-label="Subdivisões do lançamento">
      <div className="extra-fields-header">
        <h3>Subdivisões {editable && '(opcional)'}</h3>
        {editable && <button type="button" className="secondary-button compact-button" onClick={add} disabled={items.length >= 100}>Adicionar subdivisão</button>}
      </div>
      {items.length === 0 && <p className="helper-text">Adicione subdivisões para detalhar o valor. O total do lançamento será calculado pela soma delas.</p>}
      {items.length > 0 && <>
        <div className="subdivision-tabs" role="tablist" aria-label="Subdivisões">
          {items.map((current, index) => (
            <button key={index} id={`${id}-tab-${index}`} aria-controls={`${id}-panel`} type="button" role="tab" aria-selected={index === active}
              onClick={() => setSelected(index)} onKeyDown={(event) => {
                if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
                  event.preventDefault();
                  const next = (index + (event.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length;
                  setSelected(next);
                  event.currentTarget.parentElement.children[next].focus();
                }
              }} tabIndex={index === active ? 0 : -1}>
              {current.description || `Subdivisão ${index + 1}`}
            </button>
          ))}
        </div>
        <div id={`${id}-panel`} role="tabpanel" aria-labelledby={`${id}-tab-${active}`} className="subdivision-content">
          {editable ? <>
            <label>Descrição da subdivisão
              <input value={item.description} maxLength={180} onChange={(event) => update('description', event.target.value)} placeholder="Ex.: Escola Lápis de Cor" />
            </label>
            <label>Valor da subdivisão
              <input type="number" inputMode="decimal" min="0.01" step="0.01" value={item.amount} onChange={(event) => update('amount', event.target.value)} />
            </label>
            <button type="button" className="danger-button" onClick={() => onChange(items.filter((_, index) => index !== active))}>Remover subdivisão</button>
          </> : <p>{item.description}: <strong>{formatCurrency(item.amount)}</strong></p>}
        </div>
        {editable && <small className="helper-text">Tipo, status e datas são os do lançamento principal. Ao remover todas as subdivisões, informe o valor diretamente no lançamento.</small>}
      </>}
    </section>
  );
}
